import React from 'react';
import PropTypes from 'prop-types';
import EngineScoringClassificationHeaderComponent from './EngineScoringClassificationHeaderComponent';

const EngineScoringClassificationHeaderContainer = ({
  scoringClassification,
  engineClassificationIndex,
  collectionValidation,
  dispatch,
  isReadOnly,
  onSave,
  dictionaryApplicationPage,
  dictionaryScoringResponseState
}) => {
  return (
    <EngineScoringClassificationHeaderComponent
      scoringClassification={scoringClassification}
      engineClassificationIndex={engineClassificationIndex}
      dictionaryScoringResponseState={dictionaryScoringResponseState}
      dictionaryApplicationPage={dictionaryApplicationPage}
      collectionValidation={collectionValidation}
      dispatch={dispatch}
      isReadOnly={isReadOnly}
      onSave={onSave}
    />
  );
};

EngineScoringClassificationHeaderContainer.propTypes = {
  scoringClassification: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  engineClassificationIndex: PropTypes.number.isRequired,
  collectionValidation: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  dictionaryApplicationPage: PropTypes.array.isRequired,
  dictionaryScoringResponseState: PropTypes.array.isRequired
};

export default EngineScoringClassificationHeaderContainer;
